import React, { useEffect, useState, useRef} from 'react' 
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter } from 'react-router-dom'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18n from './components/pages/i18n';
import CookieBanner from './components/pages/CookieBanner';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { LanguageProvider, useLanguage } from './components/pages/LanguageContext'; 
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <I18nextProvider i18n={i18n}>
    <LanguageProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
    </LanguageProvider>
  </I18nextProvider>
  <CookieBanner />
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
